import React from 'react'

interface Transaction {
    impact: string
    date: string
    transactionType: string
    category: string[]
    amount: number | string
    icon?: React.ReactNode
    fiat: string
}

export function TransactionCryptoItem({
    impact,
    date,
    transactionType,
    amount,
    icon,
    fiat,
}: Transaction) {
    const dataClasses = 'not-italic font-light text-sm leading-3 py-4'
    const normalClasses = ' text-gray text-opacity-80 capitalize'
    const enfasisClasses = ' text-black '
    return (
        <tr className='border-b border-solid border-gray border-opacity-10 group'>
            <td className={`${dataClasses} ${enfasisClasses}`}>{icon}</td>
            <td className={`${dataClasses} ${normalClasses}`}>
                {transactionType}
            </td>
            <td className={`${dataClasses} ${normalClasses}`}>{date}</td>
            <td className={`${dataClasses} ${normalClasses}`}>{impact}</td>
            <td
                className={`${dataClasses} ${enfasisClasses} text-right whitespace-nowrap`}>
                {amount}
            </td>
            <td
                className={`${dataClasses} ${enfasisClasses} font-medium text-right whitespace-nowrap`}>
                {fiat}
            </td>
        </tr>
    )
}
